"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationPinIcon20Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.LocationPinIcon20Solid = forwardRef_1.forwardRef('LocationPinIcon20Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.753 5.475c-2.401 4.715 1.465 9.08 4.817 12.71.763.826 2.087.819 2.846-.01 3.316-3.62 7.19-7.89 4.875-12.61-1.19-2.428-3.6-3.902-6.29-3.902-2.654 0-5.039 1.436-6.248 3.812Zm6.246 6.611a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666Z" })));
});
